<template>
  <div class="splashBox flex align-items_center justify-content_center">
    <div class="splashContent">
      <div class="splashImgBox">
        <img loading="lazy" class="splashImg" :src="$common.getTitleLogo('logo')" alt />
        <!-- <img loading="lazy" class="splashImg" v-lazy="require('../../assets/images/amjs/logo.png')" alt /> -->
      </div>
      <p style="color:#E91919;">LOADING...</p>
      <div class="splashLoad">
        <div>
          <img loading="lazy" class="loading" :src="require('../../assets/images/xf/progressbar.png')" alt />
        </div>
        <img loading="lazy" :style="{left:left + '%',transition: transition + 'ms'}" class="slider" :src="require('../../assets/images/xf/progresspoint.png')" alt />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  'name': 'Splash',
  'props': {
    'msg': String
  },
  data() {
    return {
      'window': window,
      left: 0,
      transition: 5000
    };
  },
  mounted () {
    setTimeout(() => {
      this.left = 60
    }, 100)
  },
  methods: {
    // 加载完毕
    over () {
      this.transition = 500
      this.left = 88
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.splashBox {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0px;
  top: 0px;
  background-size: cover;
  z-index: 999999;
  background-color: #050010;
}
.splashContent {
  width: 766px;
  display: flex;
  align-items: center;
  flex-direction: column;
  p {
    font-size: 24px;
    color: #d4a74b;
    margin-top: 37px;
    letter-spacing: 2px;
  }
  .splashLoad {
    width: 100%;
    position: relative;
    .loading {
      width: 100%;
    }
    .slider {
      width: 100px;
      height: 100px;
      position: absolute;
      top: -120%;
    }
  }
}
.splashImgBox {
  position: relative;
  // width: 80%;
}
.defaultUserImgDong {
  width: 100% !important;
  position: absolute;
  left: 0px;
  top: 0px;
}
</style>
